<template>
  <!-- 添加线下付款申请单 -->
  <div class="jy-form-container">
    <!-- 按钮组 -->
    <div class="button-ground">
      <el-button
        class="jy-button active"
        @click="addOrUpdateEntruckDetail"
        >保存</el-button
      >
    </div>
    <div class="form-line"></div>
    <!-- 基本信息 -->
    <div class="jy-line-container">
      <AngleDouble title="基本信息">
        <el-form
          :model="baseInfoForm"
          :rules="baseInfoRules"
          label-width="150px"
          label-position="right"
        >
          <el-row :gutter="gutter">
            <el-col :span="span">
              <el-form-item label="申请编号：" class="jy-form-input">
                <el-input
                  disabled
                  class="jy-form-input"
                  v-model="baseInfoForm.number"
                  placeholder="自动生成"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="订单号\流水号："
                  prop="orderNumber"
                  class="jy-form-input"
              >
                <el-input
                    class="jy-form-input"
                    v-model.trim="baseInfoForm.orderNumber"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="申请账号：" class="jy-form-input">
                <el-select
                    v-model="baseInfoForm.applyUserName"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 10)"
                    @change="
                    onSelect(
                      $event,
                      recorderUserOptions,
                      ['applyUserId', 'applyUserName'],
                      ['userId', 'memberId']
                    )
                  "
                    clearable
                    filterable
                    remote
                    :remote-method="(val) => getMemberUserList(val)"
                >
                  <el-option
                      v-for="(item, index) in recorderUserOptions"
                      :key="index"
                      :label="item.memberId"
                      :value="item.userId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="应收金额："
                  prop="shouldAmount"
                  class="jy-form-input"
              >
                <el-input
                    type="number"
                    class="jy-form-input"
                    v-model="baseInfoForm.shouldAmount"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="税金："
                  prop="taxAmount"
                  class="jy-form-input"
              >
                <el-input
                    type="number"
                    class="jy-form-input"
                    v-model="baseInfoForm.taxAmount"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="实收金额："
                  prop="actualAmount"
                  class="jy-form-input"
              >
                <el-input
                    type="number"
                    class="jy-form-input"
                    v-model="baseInfoForm.actualAmount"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="币种：" class="jy-form-input">
                <el-select
                    v-model="baseInfoForm.currency"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 2)"
                    @change="
                    onSelect(
                      $event,
                      currencyOptions,
                      ['currencyId', 'currency'],
                      ['currencyId', 'cnName']
                    )
                  "
                    clearable
                    filterable
                    remote
                    :remote-method="(val) => getCurrencyList(val)"
                >
                  <el-option
                      v-for="(item, index) in currencyOptions"
                      :key="index"
                      :label="item.cnName"
                      :value="item.currencyId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item
                  label="汇率："
                  prop="exchangeRate"
                  class="jy-form-input"
              >
                <el-input
                    type="number"
                    class="jy-form-input"
                    v-model="baseInfoForm.exchangeRate"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="span">
              <el-form-item label="资金账号：" class="jy-form-input">
                <el-select
                    v-model="baseInfoForm.financeAssetaccount"
                    placeholder="请选择"
                    @visible-change="visibleChange($event, 1)"
                    @change="
                    onSelect(
                      $event,
                      zijingList,
                      ['financeAssetaccountId', 'financeAssetaccount'],
                      ['accountId', 'accountName']
                    )
                  "
                    clearable
                    filterable
                    remote
                    :remote-method="(val) => getCapitalAccountList(val)"
                >
                  <el-option
                      v-for="(item, index) in zijingList"
                      :key="index"
                      :label="item.accountName"
                      :value="item.accountId"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="备注：" class="jy-form-input">
                <el-input
                    class="jy-form-input"
                    v-model="baseInfoForm.comment"
                    placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="单据明细">
        <div class="button-ground">
          <el-button plain class="jy-button" @click="openShuttleA"
            >添加单据</el-button
          >
          <el-button plain class="jy-button" @click="onDelEntruckNoInfo"
            >移除</el-button
          >

        </div>
        <div class="table-ground">
          <el-table
            @selection-change="handleDispatchDetailsChange"
            class="jy-common-table"
            header-align="center"
            border
            stripe
            :highlight-current-row="true"
            style="width: 100%"
            :data="entruckDetailTable"
            show-summary
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column align="center" type="selection" width="55" ></el-table-column>

            <el-table-column align="center" prop="documentStatusShow" label="单据类型">            </el-table-column>
            <el-table-column align="center" prop="documentNumber" label="单据编号">            </el-table-column>
            <el-table-column
              align="center"
              prop="settlementAmount"
              label="结算金额"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="currency"
              label="币种"
            >            </el-table-column>
            <el-table-column align="center" prop="objectNumber" label="对象编号">            </el-table-column>
            <el-table-column align="center" prop="objectName" label="对象名称">            </el-table-column>
          </el-table>
        </div>
      </AngleDouble>
    </div>
    <div class="jy-line-container">
      <AngleDouble title="附件信息">
        <commonFuJian :data="annexTable" ref="domCommonFuJian"></commonFuJian>
      </AngleDouble>
    </div>
    <!-- 取出运单 -->
    <Dialog
      width="1200px"
      :show="waybillShow"
      :title="'选择'"
      @onCancel="waybillCancel"
      @onConfirm="waybillConfirm"
      class="dialog-padding-container"
    >
      <shuttleFrame
        :searchData="searchDataA"
        :searchResult="searchResultA"
        :tableHead="tableHeadA"
        :filterData="filterDataA"
        @getSearch="getSearchA"
        :tableLeftData="tableLeftDataA"
        :leftPageData="leftPageDataA"
        @leftPageChange="leftPageChangeA"
        @filterTable="filterTableA"
        :pageStatus="pageStatus"
      ></shuttleFrame>
    </Dialog>

  </div>
</template>
<script>
import { Api } from "@/assets/js/api";
import utils from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import MathNumBer from "@/assets/js/MathNumBer";
import commonFuJian from "@/components/fuJian/index.vue";
// 详情页排版通用组件
import AngleDouble from '@/components/details/angleDouble.vue';
import shuttleFrame from '@/components/shuttleFrame/index.vue';
import uploadimgs from "@/components/uploadImgs/index.vue";
import MessageBox from "@/components/messageBox/index.vue";
import { Message as ElMessage, MessageBox as ElMessageBox } from 'element-ui'
import objectComponentsN from '@/components/objectComponents/indexNew.vue'

export default {
  name: "BillOfflinePayAdd",
  inject: ["reload"],
  components: {
    shuttleFrame,
    uploadimgs,
    MessageBox,
    commonFuJian,
    ElMessage,
    ElMessageBox,
    AngleDouble,
    objectComponentsN
  },
  data() {
    return {
      gutter: 12,
      span: 6,
      totlaList: [
        "totalCount",
        "totalGrossWeight",
        "totalGrossVolume",
        "totalSettlementWeight",
        "totalSettlementVolume"
      ],
      pageStatus: "create",
      domCommonFuJian: null,
      annexTable: [],
      mainId: "",

      // 表单数据
      baseInfoObj: {
        id: "",
        number: "",
        orderNumber: "",
        applyUserId: "",
        applyUserName: "",
        shouldAmount: "",
        taxAmount: "",
        actualAmount: "",
        financeAssetaccountId: "",
        financeAssetaccount: "",
        currencyId: "",
        currency: "",
        comment: "",
        exchangeRate: "",
      },
      baseInfoForm: {
        id: "",
        number: "",
        orderNumber: "",
        applyUserId: "",
        applyUserName: "",
        shouldAmount: "",
        taxAmount: "",
        actualAmount: "",
        financeAssetaccountId: "",
        financeAssetaccount: "",
        currencyId: "",
        currency: "",
        comment: "",
        exchangeRate: "",
      },
      recorderUserOptions: [],
      zijingList: [],
      currencyOptions: [],


      backUpBaseInfoForm: {},
      baseInfoRules: {
        // entruckDate: [{required: true, message: "必填", trigger: "blur"}],
        // wholeCabinetType: [{required: true, message: "必填", trigger: "blur"}],
        // cabinetType: [{required: true, message: "必填", trigger: "blur"}],
        // endPort: [{required: true, message: "必填", trigger: "blur"}],
        // transportMethod: [{required: true, message: "必填", trigger: "blur"}],
        // areaCountry: [{required: true, message: "必填", trigger: "blur"}],
        // entruckStorageName: [{required: true, message: "必填", trigger: "blur"}],
        // arrivalStorageName: [{required: true, message: "必填", trigger: "blur"}]
      },
      // 下拉框数据
      wholeCabinetTypeOptions: [],
      cabinetTypeOptions: [],
      areaCountryOptions: [],
      shipAirlinesOptions: [],
      transportMethodOptions: [],
      partnerChannleNameOptions: [],
      storageNameOptions: [],

      entruckDetailTable: [],
      financialInformationTable: [],
      addPLwaybillNumbers: {
        numbers: ""
      },
      addPayableInfo: {
        financeItemServiceId: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        unitPrice: "",
        amount: "",
        currency: "",
        currencyId: "",
        objectStatusConfDictId: "",
        objectStatus: "",
        objectName: "",
        objectNameId: "",
        objectNumber: "",
        paymentMethodConfDictId: "",
        paymentMethod: "",
        remarks: "",
        createUser: "",
        updateTime: "",
        files: []
      },
      addPayableInfoRules: {
        objectStatusConfDictId: [{required: true, message: "必填", trigger: "change"}],
        itemCategoryId: [{required: true, message: "必填", trigger: "change"}],
        amount: [{required: true, message: "必填", trigger: "change"}],
        currency: [{required: true, message: "必填", trigger: "change"}],
        paymentMethodConfDictId: [{required: true, message: "必填", trigger: "change"}]
      },
      feiYongTit: "添加费用",
      dialogVisible: false,
      dialogFileNameLists: [],
      financialInformationIndex: 0,
      financialInformationTableObj:{
        financeItemServiceId: "", //财务费项id
        itemCategoryId: "", //费项类型id
        itemCategoryName: "", //费项类型
        itemServiceId: "", //费项id
        itemServiceName: "", //费项
        unitPrice: "", //单价
        amount: "", //总计金额
        currency: "", //币种
        currencyId: "",
        objectStatusConfDictId: "", //结算对象类型
        objectStatus: "", //结算对象类型名称
        objectName: "", //结算对象
        objectNameId: "",
        objectNumber: "", //结算对象编号
        paymentMethodConfDictId: "", //付款方式id
        paymentMethod: "", //付款方式
        remarks: "", //备注
        createUser: "", //操作人
        updateTime: "", //操作时间
        files: [],
      },
      backupFinancialInformationTable : {},

      objectStatusDataList: [],
      objectStatusOptions: [],
      paymentMethodOptions: [],
      itemcategoryTypeOptions: [],
      itemServiceOptions: [],
      objectNameOptions: [],
      waybillShow: false,
      dispatchDetailsMultipleSelection: [],
      // 查询的类型
      searchDataA: [
        { title: "单据编号", type: "text", key: "number", labelWidth: "60" },
        { title: "运单号", type: "text", key: "waybillNumber", labelWidth: "60" },
        {
          title: "客户名称",
          type: "userMemberName",
          key: "userMemberName",
          labelWidth: "90",
        },
        { title: "客户ID", type: "hidden", key: "userMemberId", labelWidth: "90" },
        {
          title: "核销状态",
          type: "ajax",
          key: "writeoffStatus",
          parms: {
            label: "stateShow",
            value: "state",
          },
          labelWidth: "90",
          isAjax: true,
          ajaxParms: "down_list_finance_writeoff_status",
          ajaxType: 1,
          options: [],
        },

      ],

      searchResultA: {
        number: "",
        userMemberName: "",
        userMemberId: "",
        intoStorageId: "",
        startTime: "",
      },

      tableHeadA : [
        { name: "documentStatusShow", label: "单据类型", width: 120, isShow: true },
        { name: "documentNumber", label: "单据编号", width: 120, isShow: true },
        { name: "waybillNumber", label: "运单号", width: 120, isShow: true },
        { name: "memberId", label: "会员号", width: 120, isShow: true },
        { name: "totalFreight", label: "结算金额", width: 100, isShow: true },
        { name: "currency", label: "币种", width: 100, isShow: true },
        { name: "approveTime", label: "审核时间", width: 60, isShow: true },
        { name: "statementNumber", label: "对账单编号", width: 60, isShow: true },
        { name: "unwriteoffAmount", label: "未核销金额", width: 60, isShow: true },
      ],
      filterDataA : [],
      tableLeftDataA : [],
      leftPageDataA: {
        page: 1,
        size: 20,
        total: 0,
      },
    };
  },
  mounted() {
    this.windowResize();
    this.leftPageDataA.total = this.tableLeftDataA.length;
    this.annexTable = [];
    this.backupFinancialInformationTable = utils.relObjRam(this.financialInformationTableObj);
    window.addEventListener("resize", this.windowResize);
    const query = this.$route.query;
    const meta = this.$route.meta;

    //获取柜单详情
    let id = query.id;
    let pageType = query.pageType;
    if("create" !== pageType) {
      this.baseInfoForm.id = id;
      this.baseInfoObj.id = id;
      this.pageStatus = pageType;
      this.getDetailsData(id);
    }

  },
  watch: {


  },
  methods: {
    // 窗口大小变化时调整布局
    windowResize() {
      let clientWidth = document.body.clientWidth;
      this.span = clientWidth <= 1760 ? 8 : 6;
    },
    // 查询详情页数据  -- begin
    async getDetailsData(id){
      let obj = {
        conditonKey: "billOfflinePayId",
        conditonVal: id,
      };
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中...",
        background: "rgba(255, 255, 255, 0)"
      });
      await this.onGetBaseInfo(obj);
      loading.close();
      await this.onGetEntruckDetailData(obj);
      await utils.jySleep();
      await this.onGetEntruckDetailFileData(obj);
    },
    // 附件列表
    async onGetEntruckDetailFileData(obj){
      let params4 = {
        conditionReqs: [obj],
        number: "admin_bill_offline_pay_file",
      };
      let arr = [];
      await Api.runReport(params4).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              if (datas.length > 0) {
                datas.forEach((item) => {
                  arr.push({
                    fileName: item.fileName,
                    fileId: item.fileId,
                    documentType: item.documentType,
                    createTime: item.createTime,
                    operationUserName: item.operationUserName,
                    operationType: "UPDATE",
                  });
                });
              }
              this.annexTable = arr;
            }
          }
        }
      });
    },

    // 装柜配载详情明细
    async onGetEntruckDetailData(obj){
      let params2 = {
        conditionReqs: [obj],
        number: "admin_bill_offline_pay_bill_info",
      };
      await Api.runReport(params2).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              this.entruckDetailTable = datas;
            }
          }
        }
      });
    },
    // 装柜配载详情
    async onGetBaseInfo(obj){
      let params1 = {
        conditionReqs: [obj],
        number: "admin_bill_offline_pay_detail",
      };
      await Api.runReport(params1).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            if (utils.jyCheckObjectType(datas) == "Array") {
              const obj = datas[0];
              // 基本信息
              utils.oldObjToNewObj(this.baseInfoForm, obj);
            }
          }
        }
      });
    },


    // 下拉框数据加载
    visibleChange(val, type) {
      if (val) {
        if (type == 1) {
          Api.capitalAccountList().then((res) => {
            // console.log(res.data.result);
            this.zijingList = res.data.result;
            // console.log("资金", res.data);
          });
        }else if (type == 2) {
          utils.getSelectData("", 4).then((res) => {
            this.currencyOptions = res.arr;
          });
        }else if (type == 10) {
          utils.getSelectData("down_list_member_user", 1).then((res) => {
            this.recorderUserOptions = res.arr;
          });
        }
      }
    },

    // 获取资金账号列表
    getCapitalAccountList(val) {
      Api.capitalAccountList().then((res) => {
        //console.log(res.data.result);
        this.zijingList = res.data.result;
        //console.log("资金", res.data);
      });
    },
    // 获取币种列表
    getCurrencyList(val) {
      utils.getSelectData("", 4).then((res) => {
        this.currencyOptions = res.arr;
      });
    },
    getMemberUserList(val) {
      const arrs = [
        {
          conditonKey: "memberId",
          conditonVal: val,
        },
      ];
      utils.getSelectData("down_list_member_user", 1, arrs).then((res) => {
        this.recorderUserOptions = res.arr;
      });
    },

    // 表单字段选择器联动
    onSelect(val, arr, type, select) {
      if (type[1]) {
        const obj = utils.jyIDGetContent(arr, select[0], val);
        if (obj) {
          this.baseInfoForm[type[1]] = obj[select[1]];
        }
      }
      this.baseInfoForm[type[0]] = val;
    },

    // 保存或更新装柜信息
    addOrUpdateEntruckDetail() {

      let params = Object.assign({}, this.baseInfoForm, {
        files: [...this.$refs.domCommonFuJian.annexTable, ...this.$refs.domCommonFuJian.DELFilesList],
        // financeItems: this.financialInformationTable,
        documentKeys: this.entruckDetailTable.map(({ waybillNumber, ...rest }) => rest)
      });

      if (this.pageStatus === "modify") {
        Api.updateBillOfflinePay(params).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            ElMessage({ message: data.message, type: data.status });
          }
        });
      } else {
        Api.addBillOfflinePay(params).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            this.$message.warning( data.message);
            // ElMessage({ message: data.message, type: data.status });
            if (data.status === "success") {
              // bus.emit("refreshCurrent");
              this.$confirm("添加成功", "提示:", {
                confirmButtonText: "继续添加",
                cancelButtonText: "继续操作当前单据",
              })
                  .then(() => {
                    this.reload();
                  })
                  .catch(() => {
                    this.reload();
                    this.$router.push({
                      path: "/pages/v4/finance/billOfflinePayEdit",
                      query: {
                        pageType: "modify",
                        id: res.data.result.id,
                      },
                    });
                  });
            }
          }
        });
      }
    },

    // 打开运单穿梭框
    openShuttleA() {
      this.waybillShow = true;
    },

    // 关闭运单穿梭框
    waybillCancel() {
      this.waybillShow = false;
    },

    // 确认选择运单
    waybillConfirm() {
      if (this.filterDataA.length > 0) {
        this.filterDataA.forEach((value) => {
          if (!this.entruckDetailTable.some((m) =>
              m.documentNumber === value.documentNumber
              && m.documentStatus === value.documentStatus
          )) {
            let obj = {
              id: value.id,
              documentNumber: value.documentNumber,
              documentStatus: value.documentStatus,
              documentStatusShow: value.documentStatusShow,
              settlementAmount: value.totalFreight,
              currency: value.currency,
              objectNumber: value.objectNumber,
              objectName: value.objectName,

            };
            this.entruckDetailTable.push(obj);
          }
        });
        this.waybillShow = false;
      } else {
        this.$message.warning('请选择表格数据');
      }
    },

    // 过滤运单数据
    filterTableA(e) {
      this.filterDataA = e;
    },

    // 分页加载运单数据
    leftPageChangeA(e) {
      this.leftPageDataA.page = e;
      this.onRunPageReportA(this.queryShuttleFrameA);
    },

    // 搜索运单数据
    getSearchA(e) {
      console.info("查询",e)
      let arr = Object.keys(e);
      if (arr.length > 0) {
        let qArr = [];
        for (let i in e) {
          console.info("循环",i)
          if (e[i]) {
            let val = e[i];
            if (val === null || val === undefined) {
              continue; // 跳过无效值
            }
            if (i === "endTime") {
              let times = val.split(" ") || [];
              if (times.length > 1 && times[1] === "00:00:00") {
                times[1] = "23:59:59";
                val = times.join(" ");
              }
            }
            qArr.push({ conditonKey: i, conditonVal: val });
          }
        }
        this.queryShuttleFrameA = qArr;
        this.onRunPageReportA(qArr);
      }
    },

    // 运单表格数据选中
    handleDispatchDetailsChange(val) {
      this.dispatchDetailsMultipleSelection = val;
    },


    // 移除运单
    onDelEntruckNoInfo() {
      if (this.dispatchDetailsMultipleSelection.length > 0) {
        ElMessageBox.confirm("是否删除选定数据？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.dispatchDetailsMultipleSelection.forEach((value) => {
            this.entruckDetailTable.forEach((item, index) => {
              if (value.documentNumber === item.documentNumber) {
                this.entruckDetailTable.splice(index, 1);
              }
            });
          });
        }).catch(() => {});
      } else {
        ElMessage({ message: "请选择装载明细表格数据", type: "warning" });
      }
    },


    // 文件上传
    dialogChangeFileList(array) {
      if (Array.isArray(array)) {
        this.addPayableInfo.files = array;
        this.dialogFileNameLists = array;
      }
    },

    async onRunPageReportA(arr) {
      await Api.runPageReport({
        conditionReqs: arr,
        number: "finance_in_select_offline_pay",
        pageStart: this.leftPageDataA.page,
        pageTotal: this.leftPageDataA.size,
      }).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          if (data.status == "success") {
            let result = data.result;
            const datas = result.datas;
            this.leftPageDataA.total = datas.pageCount;
            this.leftPageDataA.size = datas.pageTotal;
            this.leftPageDataA.page = datas.pageStart;
            let tableArr = datas.data;
            if (utils.jyCheckObjectType(tableArr) == "Array") {
              if (tableArr.length > 0) {
                this.tableLeftDataA = tableArr;
              } else {
                this.tableLeftDataA = [];
              }
            } else {
              this.tableLeftDataA = [];
            }
          } else {
            this.tableLeftDataA = [];
          }
        }
      });
    },
  },


}

</script>
<style scoped lang="scss">
@import "@/assets/css/common.scss";
.jy-form-container {
  padding: 20px;
  padding-bottom: 100px;
  background: #fff;
  border-radius: 6px;
}

.form-line {
  margin-top: 20px;
  height: 1px;
  background: #ccc;
}

.tag-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.tag-list {
  display: flex;
  margin-top: 15px;

  .tag-span {
    width: 80px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    border: 2px dashed red;
    color: red;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
  }
}
</style>